/* ==========================================================================
   Burly — quick-view.js
   Opens a modal with product content fetched via the Section Rendering API
   (/products/<handle>?section_id=quick-view). Add-to-cart inside the modal
   goes through Burly.cart so the drawer opens on success.
   ========================================================================== */

(function () {
  'use strict';

  const modal = () => document.getElementById('QuickViewModal');
  const content = () => document.querySelector('[data-quick-view-content]');

  let lastFocused = null;

  function open() {
    const el = modal();
    if (!el) return;
    lastFocused = document.activeElement;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    document.body.classList.add('overlay-open');
    document.addEventListener('keydown', onEscape);
    const closeButton = el.querySelector('.quick-view__close');
    if (closeButton) closeButton.focus();
  }

  function close() {
    const el = modal();
    if (!el) return;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('overlay-open');
    document.removeEventListener('keydown', onEscape);
    // Reset to spinner for the next open.
    if (content()) content().innerHTML = '<div class="quick-view__spinner" aria-hidden="true"></div>';
    if (lastFocused) lastFocused.focus();
  }

  function onEscape(event) {
    if (event.key === 'Escape') close();
  }

  async function load(productUrl) {
    open();
    try {
      const separator = productUrl.includes('?') ? '&' : '?';
      const response = await fetch(productUrl + separator + 'section_id=quick-view');
      if (!response.ok) throw new Error(response.statusText);
      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const inner = doc.querySelector('.quick-view-product');
      if (inner && content()) {
        content().innerHTML = '';
        content().appendChild(inner);
      }
    } catch (error) {
      // Rendering failed — just go to the product page.
      window.location.href = productUrl;
    }
  }

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-quick-view]');
    if (trigger) {
      event.preventDefault();
      load(trigger.dataset.quickView);
      return;
    }
    if (event.target.closest('[data-quick-view-close]')) {
      event.preventDefault();
      close();
    }
  });

  // AJAX add-to-cart from inside the modal.
  document.addEventListener('submit', (event) => {
    const form = event.target.closest('[data-quick-view-form]');
    if (!form || !window.Burly || !Burly.cart) return;
    event.preventDefault();

    const button = form.querySelector('[name="add"]');
    if (button) button.disabled = true;

    Burly.cart
      .add(new FormData(form))
      .then(() => close())
      .catch((error) => alert(error.message))
      .finally(() => {
        if (button) button.disabled = false;
      });
  });
})();
